import { Animated } from 'react-native';
import React, { useCallback, useEffect, useRef } from 'react';

import { makeStyles } from '@providers/Theme';

type CollapsableProps = {
  open: boolean;
  children: React.ReactNode;
  testID: string;
};

const useStyles = makeStyles(() => ({
  root: {
    overflow: 'hidden',
    width: '100%',
  },
}));

export const Collapsable: React.FC<CollapsableProps> = ({
  children,
  open,
  testID,
}) => {
  const styles = useStyles();
  const maxHeight = useRef(new Animated.Value(0)).current;

  const expand = useCallback(() => {
    Animated.timing(maxHeight, {
      toValue: 1000,
      duration: 200,
      useNativeDriver: false,
    }).start();
  }, [maxHeight]);

  const collapse = useCallback(() => {
    Animated.timing(maxHeight, {
      toValue: 0,
      duration: 200,
      useNativeDriver: false,
    }).start();
  }, [maxHeight]);

  useEffect(() => {
    if (open) {
      expand();
    } else {
      collapse();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Animated.View style={[styles.root, { maxHeight }]} testID={testID}>
      {children}
    </Animated.View>
  );
};
